import { children, id } from "./power";
import { deleteNull } from "@src/utils";
const power = {
    ...children,
    ...{
        [id.id]: id
    }
};

export default class BoardApi {
    /**
     * 获取数据
     * @param {any} params
     * @returns
     * @memberOf BoardApi
     */
    // [power[id.id].apiName](params) {
    //     let url = power[id.id].url
    //     return this.POST(url, deleteNull(params))
    // }

    // [children.ADD_DATA.apiName](params) {
    //     let url = children.ADD_DATA.url
    //     return this.POST(url, params)
    // }

    //获取柱状图
    getShipmentHistogram(params) {
        return this.POST("wms/kanban/shipment/treeMap", params);
    }

    //获取饼图
    getShipmentPiechart(params) {
        return this.POST("wms/kanban/shipment/roundMap", params);
    }

    //获取看板列表图
    getShipmentMonitor(params) {
        return this.POST("wms/kanban/shipment/list", params);
    }
}
